import config from '@epi-config';

export const externalReportsApiUrl = `${config.apiHost}/api/external-reports`;
